import "./notification.scss";

import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";
import hasAncestorOfClass from "../../utils/hasAncestorOfClass";
import uniqueId from "../../utils/uniqueId";
import Icon from "../interface/Icon";
import NotificationActionView from "./NotificationActionView";

let notificationTimer;
const clickWasNotification = e => hasAncestorOfClass(e.target, "notification");

class NotificationView extends React.Component {
  constructor(props) {
    super(props);

    this.onWindowClick = this.onWindowClick.bind(this);

    this._closeOnClick = false;
  }

  componentDidMount() {
    window.addEventListener("mousedown", this.onWindowClick);
    notificationTimer = setTimeout(() => {
      this._closeOnClick = true;
    }, 3000);
  }

  componentDidUpdate() {
    clearTimeout(notificationTimer);
    notificationTimer = setTimeout(() => {
      this._closeOnClick = true;
    }, 3000);
  }

  componentWillUnmount() {
    window.removeEventListener("mousedown", this.onWindowClick);
    clearTimeout(notificationTimer);
  }

  onWindowClick = e => {
    if (this._closeOnClick && !clickWasNotification(e)) {
      this.props.onCloseClick();
    }
  };

  createActionViews = () => {
    const { actions, onCloseClick, onActionLinkClick } = this.props;
    return actions.map((actionRecord, index) => {
      return (
        <NotificationActionView
          key={index}
          label={actionRecord.label}
          onClick={() => {
            onActionLinkClick(actionRecord.action);
            if (actionRecord.autoDismiss) {
              onCloseClick();
            }
          }}
        />
      );
    });
  };

  render() {
    const { label, onCloseClick } = this.props;
    return label ? (
      <div className={`notification ${this.props.position ? this.props.position : ""}`} key={uniqueId()}>
        <div className="notificationContent">
          <span className="notificationMessage">{label}</span>
          <div className="notificationActionsContainer">{this.createActionViews()}</div>
        </div>
        <div className="notificationButtonsContainer">
          <div className="notificationCloseButtonContainer">
            <Icon icon="interfaceClose" color="iconMono" onClick={onCloseClick} />
          </div>
        </div>
      </div>
    ) : (
      false
    );
  }
}

NotificationView.propTypes = {
  label: PropTypes.string.isRequired,
  actions: PropTypeShapes.uiNotificationActionList,
  onCloseClick: PropTypes.func.isRequired,
  onActionLinkClick: PropTypes.func.isRequired,
  position: PropTypes.string
};

export default NotificationView;
